<template>
    <div>
        <v-container>
            <v-form ref="form">
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}<span class="page_title_value">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>
                
                <v-container
                    id="scroll-target"
                    class="overflow-y-auto px-5"
                >

                <v-card>
                    <div class="ma-4">
                        <v-subheader class="blue--text">{{$t('reportsparam.parameters')}}</v-subheader>
                        <v-row>
                            <v-col cols="4" sm="4" class="pb-n5">
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('reportsparam.year')"
                                    type="text"
                                    ref="year"
                                    hide-selected
                                    v-model="formData.poyr"
                                    :items="yearList"
                                    dense
                                    :rules="[rules.required]"
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="4" sm="2" class="pb-n5">
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('reportsparam.month')"
                                    type="text"
                                    ref="month"
                                    hide-selected
                                    v-model="formData.pomth"
                                    :items="monthList"
                                    dense
                                    :rules="[rules.required]"
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="4" sm="6" class="pb-n5">
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('reportsparam.payout')"
                                    type="text"
                                    ref="payout"
                                    hide-selected
                                    v-model="formData.poid"
                                    :items="payoutcodeList"
                                    dense
                                    :rules="[rules.required]"
                                    clearable
                                    @change="changePayoutcodeHandler(formData.poid)"
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="4" sm="4" class="pb-n5">
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('columns.company')"
                                    type="text"
                                    ref="company"
                                    hide-selected
                                    v-model="formData.compnycode"
                                    :items="compnycodeList"
                                    dense
                                    :rules="[rules.required]"
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                        </v-row>
                    </div>
                </v-card>

                </v-container>

                <v-row>
                    <div class="pt-5 pl-6 pb-4">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="warning" 
                            style="width: 100px"
                            @click="goHandler" 
                            > 
                            {{$t('button.go')}}
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row>

            </v-form>
        </v-container>
    </div>
</template>

<script>

// import moment from 'moment'


export default {
    props: {
        parentObject: Object
    },

    components: {
      
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                },
            },
            formData: {
                poyr: null,
                pomth: null,
                poid: null,
                compnyid: null,
                compnycode: null,
                // payitemid: null,
                payoutcode: null,
                total: 0,
            },
            
            yearList: [],
            monthList: [],
            payoutcodeList: [],
            payoutList: [],
            compnycodeList: [],
          //  payitemcodeList: [],
            compnycodes: [],

        }
    },

    methods: {

        loadYear(){
            const vm = this;

            this.$store.dispatch('get', {
                url: '/salhd/all'})
                .then(res => {                    

                    for (let i = 0; i < res.data.rec.length; i++) {
                        const x = vm.yearList.filter(function(x) {
                            return x == res.data.rec[i].poyr;
                        })[0];

                        if (!x || x == undefined) {
                            vm.yearList.push(res.data.rec[i].poyr)
                        }                  
                    }
                    vm.yearList.sort(function(a, b){return a-b});
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },

        loadMonth(){
            const vm = this;

            this.$store.dispatch('get', {
                url: '/salhd/all'})
                .then(res => {

                    for (let i = 0; i < res.data.rec.length; i++) {
                        const x = vm.monthList.filter(function(x) {
                            return x == res.data.rec[i].pomth;
                        })[0];

                        if (!x || x == undefined) {
                            vm.monthList.push(res.data.rec[i].pomth)
                        }                 
                    }
                    vm.monthList.sort(function(a, b){return a-b});
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },

        loadPayoutCode(){
            const vm = this;

            this.$store.dispatch('get', {
                url: '/vw_pyctrl/all'})
                .then(res => {
                    vm.poid = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.payoutcodeList.push(
                            {
                                text: res.data.rec[i].payoutcode,
                                value: res.data.rec[i].id
                            }
                        )
                        
                        vm.payoutList.push(res.data.rec[i])
                    }

                    if (vm.formData.poid) {
                        vm.changePayoutcodeHandler(vm.formData.poid);
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },

        changePayoutcodeHandler(id) {
            let payoutitem = this.payoutList.find(item => item.id === id);
            this.formData.payoutcode = payoutitem.payoutcode
        },

        loadCompnyCode(){
            const vm = this;

            this.$store.dispatch('get', {
                url: '/salhd/all'})
                .then(res => {
                    vm.compnycodes = res.data.rec;

                 //   console.log('compnycodes', vm.compnycodes)

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.compnycodeList.push(
                            {
                                text: res.data.rec[i].compnydesc,
                                value: res.data.rec[i].compnycode
                            }
                        )                        
                    }

                  //  console.log('codelist', vm.compnycodeList)

                    if (vm.formData.compnycode) {
                        vm.changeCompnycodeHandler(vm.formData.compnycode);
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },

        changeCompnycodeHandler(id) {
            this.compnycodes.find(item => item.id === id);
            
        },

        // loadPayitemCode(){
        //     const vm = this;

        //     axios.get(this.$store.getters.apiURL + '/vw_salpayitem/all')
        //         .then(res => {
        //             vm.payitemcodes = res.data.rec;

        //             for (let i = 0; i < res.data.rec.length; i++) {
        //                 vm.payitemcodeList.push(
        //                     {
        //                         text: res.data.rec[i].payitemdesc,
        //                         value: res.data.rec[i].payitemcode
        //                     }
        //                 )                        
        //             }

        //             if (vm.formData.payitemcode) {
        //                 vm.changePayitemcodeHandler(vm.formData.payitemcode);
        //             }
        //         })
        //         .catch(err => {
        //             vm.isErr = true;
        //             vm.errMsg = err;
        //             vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
        //         });
        // },

        // changePayitemcodeHandler(id) {
        //     this.payitemcodes.find(item => item.id === id);
            
        // },

        goHandler(){
            const vm = this;

            const dataHolder = {
                poid: this.formData.poid,
                pomth: this.formData.pomth,
                poyr: this.formData.poyr,
            }

            const formData = this.formData
            
            var getdata = [];

            for (const key in dataHolder) {
                if (dataHolder[key]) {
                    getdata.push(dataHolder[key])
                }
            }

            if (this.formData.compnycode && getdata.length > 0) {

                switch (getdata.length) {
                    case 1:
                        this.$router.push({name: 'hrdflistingdetails', params: { formData } });
                        break;
                    case 2:
                        var poidHolder1 = vm.poid.filter(function(x) {
                            return  (x.id == vm.formData.poid &&
                                    (x.pymonth == vm.formData.pomth || 
                                     x.pyyear == vm.formData.poyr)) || (
                                     x.pymonth == vm.formData.pomth &&
                                     x.pyyear == vm.formData.poyr)
                            })[0]
                        
                        if (poidHolder1) {
                            this.$router.push({name: 'hrdflistingdetails', params: { formData } });
                        } else {
                            //this.$refs.form.validate()
                            vm.isErr = true;
                            vm.errMsg = this.$t('miscpayrolllsitreport.inconsistencymsg');
                            
                            vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                        }
                        break;
                    case 3:
                        var poidHolder2 = vm.poid.filter(function(x) {
                            return  x.id == vm.formData.poid &&
                                    x.pymonth == vm.formData.pomth && 
                                    x.pyyear == vm.formData.poyr
                            })[0]
                        
                        if (poidHolder2) {
                            this.$router.push({name: 'hrdflistingdetails', params: { formData } });
                        } else {
                            //this.$refs.form.validate()
                            vm.isErr = true;
                            vm.errMsg = 'There are inconsistencies in parameter selection';
                            
                            vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                        }
                        break;
                }
            } else {
                this.$refs.form.validate()
            }
            
        },

        updateValue() {
            this.$emit("input", {
                poyr: this.formData.poyr,
                pomth: this.formData.pomth,
                poid: this.formData.poid,
                compnycode: this.formData.compnycode,
             //   payitemcode: this.formData.payitemcode,
            });
        },
    }, 

    mounted() { 
      this.loadYear();
      this.loadMonth();
      this.loadPayoutCode();
      this.loadCompnyCode();
 // this.loadPayitemCode();
     
    },
    
}
</script>